import React, { useMemo } from "react";
import ConstellationMap from "./ConstellationMap";
import { getChapterStars, goalStars, getTotalStars } from "../utils/stars";

export default function ConstellationInlineModal({ open, onClose }) {
  const collected = useMemo(() => {
    const map = getChapterStars();
    const arr = [];
    for (let ch = 2; ch <= 9; ch += 1) {
      const v = Number(map?.[`chapter-${ch}`] || map?.[ch] || 0) > 0;
      arr.push(v);
    }
    return arr;
  }, []);

  const total = getTotalStars();
  const goal = goalStars();

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[1400] bg-black/60 backdrop-blur-sm flex items-center justify-center p-3"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Star Quest"
    >
      {/* ~10% smaller than previous */}
      <div
        className="relative w-[81vw] md:w-[68vw] max-w-[890px] bg-white rounded-2xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-3 border-b">
          <div>
            <div className="text-xl font-bold">Star Quest</div>
            <div className="text-sm text-gray-600">
              {total} / {goal} stars collected
            </div>
          </div>
          <button
            onClick={onClose}
            className="rounded-md px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200"
            aria-label="Close"
          >
            Close
          </button>
        </div>

        {/* 16:9 stage */}
        <div className="relative w-full pb-[56.25%]">
          <ConstellationMap
            className="absolute inset-0 m-3 rounded-xl overflow-hidden"
            backgroundUrl={"/images/constellation_bg.png"}
            collected={collected}
            animateCompleted
            numberFontSize={16}   // 👈 smaller numbers
          />
        </div>

        <p className="text-[13px] text-gray-600 mt-2 mb-4 text-center px-4">
          Collect stars by helping Treblins in Chapters 2–9. When all eight are
          lit, Gis the Star Gazer will decipher the ancient melody.
        </p>
      </div>
    </div>
  );
}
